/** Copy for the map's "back to my location" button (Search map). */
export const mapLocateCopy = {
  /** Accessible name of the round locate button (it has no visible text). */
  buttonAriaLabel: 'Center the map on my location',
  /** Shown when location access is off (denied), and the map stays put. */
  locationOffToast: 'Turn on location access to center the map on you.',
  /** Shown when access is on but the location could not be read in time (no signal, a timeout). */
  locationUnavailableToast: "We couldn't get your location right now. Try again in a moment.",
} as const;
